import React from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { b2cRegistryActions, useB2CRegistryState } from '@/stores/slices/b2c-registry-slice.ts'
import { useAppDispatch } from '@/stores/hooks.ts'

const MENU_ITEMS = [
  { value: 'ALL', label: 'Все' },
  { value: 'NEW', label: 'Запрос к получателю' },
  { value: 'PROCESSING', label: 'В работе' },
  { value: 'PAID', label: 'Успешно' },
  { value: 'REJECTED', label: 'Неуспешно' },
]

export const B2CRegistryStateFilter = (): React.ReactElement => {
  const { b2cState: state } = useB2CRegistryState()
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(
      b2cRegistryActions.setFilter({
        filterKey: 'b2cState',
        filterValue: event.target.value === 'ALL' ? '' : event.target.value,
      })
    )
  }

  const selectValue = state || 'ALL'

  return (
    <Select value={selectValue} onChange={handleStatusChange} items={MENU_ITEMS} label="Статус" labelId="sbp-status" />
  )
}
